import { Tooltip as PMTooltip } from '@ifood/pomodoro-components';
import React, { FC } from 'react';

import { PropsOf } from 'types/jsx';

type TooltipProps = {
  enabled?: boolean;
} & PropsOf<typeof PMTooltip>;

const Tooltip: FC<TooltipProps> = ({ children, enabled, ...props }) => {
  return enabled ? <PMTooltip {...props}>{children}</PMTooltip> : <>{children}</>;
};

export default Tooltip;
